import { render } from "./home-sec9.vue?vue&type=template&id=98365b9a"
import script from "./home-sec9.vue?vue&type=script&lang=js"
export * from "./home-sec9.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\jomon\\OneDrive\\Desktop\\algorithma-website-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__